module.exports = __webpack_public_path__ + "static/media/Throat.6220ff22.jpeg";